import { loadDismissablePrompts } from '@ms/yammer-data/dist/domains/dismissablePrompts/actions';
import { DismissablePromptKey } from '@ms/yammer-data/dist/state/types';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

export type UseLoadDismissablePrompts = (keys: DismissablePromptKey[]) => void;
export const useLoadDismissablePrompts: UseLoadDismissablePrompts = (keys) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(loadDismissablePrompts(keys));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, ...keys]);
};
